/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Create_My_VideosInputs */

const en_hotel_create_my_videos = /** @type {(inputs: Hotel_Create_My_VideosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My videos`)
};

/**
* | output |
* | --- |
* | "My videos" |
*
* @param {Hotel_Create_My_VideosInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_create_my_videos = /** @type {((inputs?: Hotel_Create_My_VideosInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Create_My_VideosInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_create_my_videos(inputs)
});
export { hotel_create_my_videos as "hotel.create.my_videos" }